import { v4 as uuidv4 } from 'uuid';

class Message {
  constructor(opts = {}) {
    this.id = opts.id;
    this.conversation_id = opts.conversation_id;
    this.sender = {
      name: opts.sender ? opts.sender.name : 'LB',
    };
    if (opts.sender && opts.sender.id) {
      this.sender['id'] = opts.sender.id.toString();
    }
    this.parts = opts.parts;
    this.sent_at = opts.sent_at;
    this.recipient_status = opts.recipient_status || {};
    this.isUnread = opts.isUnread;
    this.readStatus = opts.readStatus;
  }

  updateReadStatus() {
    let recipientStatus = this.recipient_status;
    let vals = Object.values(recipientStatus);
    const readCount = vals.filter((v) => {
      return v === 'read';
    }).length;
    let readStatus;
    if (readCount === vals.length - 1) readStatus = 'ALL';
    else if (readCount === 0) {
      readStatus = 'NONE';
    } else {
      readStatus = 'SOME';
    }
    this.readStatus = readStatus;
  }

  get sendStatus() {
    return this.checkSendStatus();
  }

  checkSendStatus() {
    if (this.sender.id) {
      return this.recipient_status['user_' + this.sender.id.toString()];
    }
  }

  sendFailed() {
    if (this.sender.id) {
      this.recipient_status['user_' + this.sender.id.toString()] = 'failed';
    }
  }

  markRead(currentUserId = null) {
    const idOfUser = this.sender.id || currentUserId;
    this.recipient_status['user_' + idOfUser.toString()] = 'read';
    this.isUnread = false;
    this.updateReadStatus();
  }

  readByOtherUser(userId) {
    this.recipient_status['user_' + userId.toString()] = 'read';
    this.updateReadStatus();
  }

  prepareToSend(currentUserId) {
    this.id = this.id || this.generateId();
    const idOfUser =
      typeof this.sender.id !== 'undefined' ? this.sender.id : currentUserId;
    this.sent_at = new Date().getTime();
    Object.keys(this.recipient_status).forEach((key) => {
      this.recipient_status[key] =
        key === 'user_' + idOfUser.toString() ? 'sending' : 'unread';
    });
  }

  generateId() {
    return 'lb:///messages/' + uuidv4();
  }

  toPlainObject() {
    let plainMessageObj = {
      id: this.id,
      conversation_id: this.conversation_id,
      sender: this.sender,
      parts: this.parts,
      sent_at: this.sent_at,
      recipient_status: this.recipient_status,
    };
    return plainMessageObj;
  }

  clone() {
    return new Message({
      id: this.id,
      conversation_id: this.conversation_id,
      sender: { ...this.sender },
      parts: this.parts ? [...this.parts] : this.parts,
      sent_at: this.sent_at,
      recipient_status: { ...this.recipient_status },
      isUnread: this.isUnread,
      readStatus: this.readStatus,
    });
  }
}

export default Message;
